export default {"src":"/_next/static/media/add_to_cart_with_blue_background..268028af.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};